import { render, staticRenderFns } from "./Evg.vue?vue&type=template&id=0b49c5c6&"
import script from "./Evg.vue?vue&type=script&lang=js&"
export * from "./Evg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports